// Typed DOM lookups.
//
// `querySelector` is declared as returning `Element`, which has no style, dataset,
// hidden, click, value... so nearly every use of it in this codebase was a type
// error. Casting at each call site would be noise; doing it once here is both
// shorter to read and makes the type checker useful instead of drowned out.

/**
 * @param {string} selector
 * @param {ParentNode} [root]
 * @returns {HTMLElement} the element, or null if absent (callers that can cope
 *   check for it; the cast keeps the checker focused on real mistakes)
 */
export function $(selector, root = document) {
	return /** @type {HTMLElement} */ (root.querySelector(selector));
}

/**
 * An array, not a NodeList, so map/filter/reduce work as well as forEach.
 * @param {string} selector
 * @param {ParentNode} [root]
 * @returns {HTMLElement[]}
 */
export function $$(selector, root = document) {
	return /** @type {HTMLElement[]} */ ([...root.querySelectorAll(selector)]);
}

/**
 * The detail of a CustomEvent, which `Event` does not declare.
 * @param {Event} event
 * @returns {any}
 */
export function detailOf(event) {
	return /** @type {CustomEvent} */ (event).detail;
}
